import Glide from '@glidejs/glide';

let glide = new Glide('.glide', {
  type: 'carousel',
  perView: 1,
  focusAt: 'center'
});
glide.mount();

